
import { defineComponent, ref, computed, watch, PropType } from 'vue'
export default defineComponent({
  name: 'PositionControl',
  props: {
    isLight: Boolean,
    colors: { type: Object as PropType<Record<string, string>>, required: true },
    initialValue: { type: Object as PropType<any>, default: null }
  },
  emits: ['change'],
  setup(props, { emit }) {
    const initCapital = ref('100')
    const maxSinglePos = ref('10')
    const maxHoldCount = ref('5')
    const maxDailyBuy = ref('2')
    const capitalError = ref('')
    const singlePosError = ref('')
    const holdCountError = ref('')
    const dailyBuyError = ref('')

    const validateCapital = () => {
      const v = Number(initCapital.value)
      if (!initCapital.value) capitalError.value = '请输入初始资金'
      else if (isNaN(v) || v <= 0) capitalError.value = '请输入有效数字'
      else if (v > 10000) capitalError.value = '最大10000万，请重新输入'
      else capitalError.value = ''
    }

    const validateInt = (field: string) => {
      const configs: Record<string, { ref: any, max: number, label: string, errRef: any }> = {
        maxSinglePos: { ref: maxSinglePos, max: 100, label: '个股最大持仓', errRef: singlePosError },
        maxHoldCount: { ref: maxHoldCount, max: 20, label: '账户最大持股数', errRef: holdCountError },
        maxDailyBuy:  { ref: maxDailyBuy,  max: 5,  label: '单日最大买入数', errRef: dailyBuyError },
      }
      const cfg = configs[field]
      if (!cfg) return
      cfg.ref.value = cfg.ref.value.replace(/[^0-9]/g, '')
      const v = Number(cfg.ref.value)
      if (!cfg.ref.value) cfg.errRef.value = `请输入${cfg.label}`
      else if (v < 0) cfg.errRef.value = '不可为负数'
      else if (v > cfg.max) cfg.errRef.value = `最大${cfg.max}${field === 'maxSinglePos' ? '%' : '只'}，请重新输入`
      else cfg.errRef.value = ''
    }

    const emitChange = () => {
      // 直接校验当前值，不依赖 error ref 的异步状态
      const capVal = Number(initCapital.value)
      const capOk = !!initCapital.value && !isNaN(capVal) && capVal > 0 && capVal <= 10000
      const singleVal = Number(maxSinglePos.value)
      const singleOk = !!maxSinglePos.value && !isNaN(singleVal) && singleVal >= 0 && singleVal <= 100
      const holdVal = Number(maxHoldCount.value)
      const holdOk = !!maxHoldCount.value && !isNaN(holdVal) && holdVal >= 0 && holdVal <= 20
      const dailyVal = Number(maxDailyBuy.value)
      const dailyOk = !!maxDailyBuy.value && !isNaN(dailyVal) && dailyVal >= 0 && dailyVal <= 5
      const valid = capOk && singleOk && holdOk && dailyOk

      emit('change', {
        initCapital: initCapital.value,
        maxSinglePos: maxSinglePos.value,
        maxHoldCount: maxHoldCount.value,
        maxDailyBuy: maxDailyBuy.value,
        valid,
      })
    }

    watch([initCapital, maxSinglePos, maxHoldCount, maxDailyBuy], emitChange, { immediate: true })

    // 口令回显
    watch(() => props.initialValue, (val) => {
      if (!val) return
      // initialFund: 元 → 万
      if (val.initialFund) initCapital.value = String(val.initialFund / 10000)
      if (val.positionLimit) maxSinglePos.value = String(val.positionLimit)
      if (val.maxHolds) maxHoldCount.value = String(val.maxHolds)
      if (val.dayLimit) maxDailyBuy.value = String(val.dayLimit)
    }, { immediate: true })

    const inputStyle = computed(() => ({
      background: props.isLight ? '#f5f5f5' : '#2a2a2a',
      color: props.colors.textPrimary,
      borderColor: props.colors.border,
    }))

    return { initCapital, maxSinglePos, maxHoldCount, maxDailyBuy, capitalError, singlePosError, holdCountError, dailyBuyError, validateCapital, validateInt, inputStyle }
  }
})
